<template>
  <v-container fluid fill-height class="pa-2">
      <v-row class="stepper">
        <v-col>
          <Stepper :type="type"></Stepper>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import Stepper from '@/components/AddDevice/Stepper.vue';

export default {
  name: 'AddDevice',
  props: {
    type: {
      type: String,
      required: false,
    },
  },
  components: {
    Stepper,
  },
};
</script>
<style scoped>
.stepper {
  height: 100vh;
}
</style>
